<template>
  <div class="order-signing-detail">
    <div v-if="type == 'singing'" class="tuolele-main-box">
      <div class="flex-wrap">
        <div class="flex-con">
          <div class="order-count">
            <span>所有订单</span>
            <p class="bold">{{ dataInfo.count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待校长审核</span>
            <p class="bold">{{ dataInfo.hold_president_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待财务/总部审核</span>
            <p class="bold">{{ dataInfo.hold_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>审核成功</span>
            <p class="bold">{{ dataInfo.audit_success_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>审核失败</span>
            <p class="bold">{{ dataInfo.audit_fail_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>学员数量（去重后）</span>
            <p class="bold">{{ dataInfo.children_unique_count }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="table-header fn-clear">
      <div class="fn-right export-btn">
        <el-button type="success" @click="exportExcel">导出Excel表</el-button>
      </div>
      <div class="fn-right table-header-right">
        <el-pagination
          :current-page.sync="search.p"
          :page-sizes="[10, 20, 30, 40, 50,100, 300,400,500,1000]"
          :page-size="search.limit"
          layout="sizes, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          @size-change="handleSizeChange"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table ref="singleTable" :data="dataInfo.list" border stripe highlight-current-row @sort-change="tableSort">
        <el-table-column prop="create_time" label="创建时间" sortable>
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.create_time.substr(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="success_time" label="签约成功时间" sortable>
          <template slot-scope="scope">
            <div class="color-black">
              {{ scope.row.success_time.substr(0, 16) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="套餐">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.item_title }}</div>
            <div class="color-gray">{{ scope.row.order_type_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="order_id" label="签约单号" />
        <el-table-column label="套餐价格/数量">
          <template slot-scope="scope">
            <div class="color-black">￥{{ scope.row.total_price / 100 }}</div>
            <div class="color-gray">X{{ scope.row.num }}</div>
          </template>
        </el-table-column>
        <el-table-column label="学员">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.sub_name }}</div>
            <div class="color-gray">ID：{{ scope.row.relation_id }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="grade_name"
          label="学员年级"
        />
        <el-table-column
          prop="master_name"
          label="家长姓名"
        />
        <el-table-column
          prop="kpi_status_name"
          label="订单类型"
        />
        <el-table-column label="实付">
          <template slot-scope="scope">
            <div class="color-black">￥{{ scope.row.actual_amount / 100 }}</div>
            <div class="color-gray">{{ scope.row.payment_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="shop_name"
          label="签约店铺"
        />
        <el-table-column label="责任人">
          <template slot-scope="scope">
            <div>
              <span class="color-gray">提交人:</span>
              {{ scope.row.editor_name }}
            </div>
            <div>
              <span class="color-gray">销售人:</span>
              {{ scope.row.salesperson_name }}
            </div>
            <div>
              <span class="color-gray">班主任:</span>
              {{ scope.row.headmaster_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="订单审核状态"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.status_name }}</p>
            <el-image
              v-if="scope.row.extra && scope.row.extra.master_autograph"
              class="cover"
              :src="scope.row.extra.master_autograph"
              :preview-src-list="[scope.row.extra.master_autograph]"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="getOrderInfo(scope.row)">{{
              type == "singing" ? "查看订单" : "审核订单"
            }}</el-button>
            <el-button
              v-if="scope.row.kpi_status_name != '赠送' && scope.row.extra"
              type="text"
              @click="orderImg(scope.row)"
            >电子合同</el-button>
            <el-button
              v-if="scope.row.invoice_status != '0' && type == 'singing'"
              type="text"
              @click="getInvoice(scope.row, '1')"
            >查看发票</el-button>
            <el-button
              v-if="scope.row.invoice_status == '0' && type == 'singing'"
              type="text"
              @click="setInvoice(scope.row, '0')"
            >编辑发票</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="search.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="search.limit"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose"
      class="order-detail-dialog"
    >
      <OrderSigningInfo
        :order-detail="orderDetail"
        :type="type"
        @updateOrderList="getSignList"
      />
    </el-dialog>
    <el-dialog
      title="发票信息"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose"
      class="order-detail-invoice"
    >
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          类型
        </div>
        <el-radio-group
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_type"
        >
          <el-radio :label="1">增值税普票</el-radio>
          <el-radio :label="2">增值税专票</el-radio>
        </el-radio-group>

        <div v-if="invoiceFlag == '1'">
          {{ invoiceDetail.invoice_type == "1" ? "增值税普票" : "增值税专票" }}
        </div>
      </div>
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          税率
        </div>
        <el-radio-group
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_tax_rate"
        >
          <el-radio :label="1">1%</el-radio>
          <el-radio :label="3">3%</el-radio>
          <el-radio :label="6">6%</el-radio>
        </el-radio-group>
        <div v-if="invoiceFlag == '1'">
          {{ invoiceDetail.invoice_tax_rate + "%" }}
        </div>
      </div>
      <div class="order-detail-item">
        <div class="color-black bold font-size16 order-detail-item-title">
          发票号
        </div>
        <div v-if="invoiceFlag == '1'">{{ invoiceDetail.invoice_no }}</div>
        <el-input
          v-if="invoiceFlag == '0'"
          v-model="invoiceDetail.invoice_no"
          clearable
        />
      </div>
      <el-button
        v-if="invoiceFlag == '1'"
        type="primary"
        class="el-button-confirm"
        @click="handleClose()"
      >确定</el-button>
      <el-button
        v-if="invoiceFlag == '0'"
        type="primary"
        class="el-button-confirm"
        @click="confirmSetInvoice"
      >确定</el-button>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible3"
      title="合同预览"
      class="order-img"
    >
      <div class="agreement_picture">
        <div class="pdf">
          <iframe
            :src="src"
            frameborder="0"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OrderSigningInfo from '@/components/order/OrderSigningInfo.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'OrderSigningDetail',
  components: {
    OrderSigningInfo
  },
  props: {
    type: String,
    search: Object
  },
  data() {
    return {
      dataInfo: {},
      itemTotal: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      orderDetail: {},
      invoiceDetail: {
        order_id: '',
        invoice_type: '1',
        invoice_no: '',
        invoice_tax_rate: '6'
      },
      invoiceFlag: '0',
      src: ''
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.getSignList()
      }
    }
  },
  mounted() {
    this.getSignList()
  },
  methods: {
    exportExcel() {
      const tHeader = [
        '创建时间',
        '签约成功时间',
        '套餐',
        '签约单号',
        '套餐价格/数量',
        '学员',
        '年级',
        '订单类型',
        '实付',
        '签约店铺',
        '责任人',
        '订单审核状态'
      ]
      const filterVal = [
        'create_time',
        'success_time',
        'item_title',
        'order_id',
        'total_price',
        'sub_name',
        'grade_name',
        'kpi_status_name',
        'actual_amount',
        'shop_name',
        'editor_name',
        'status_name'
      ]
      let list = JSON.stringify(this.dataInfo.list)
      list = JSON.parse(list)
      list.forEach(e => {
        e.item_title = e.item_title + ',' + e.order_type_name
        e.total_price = e.total_price / 100 + ',X' + e.num
        e.actual_amount = e.actual_amount / 100 + ',' + e.payment_name
        e.sub_name = e.sub_name + ',' + e.relation_id
        e.editor_name =
          '提交人:' +
          e.editor_name +
          '，销售人:' +
          e.salesperson_name +
          ',班主任:' +
          e.headmaster_name
      })
      Tool.exportExcel(tHeader, filterVal, list, '签约订单'+Tool.nowTime())
    },
    getSignList() {
      this.dialogVisible1 = false
      this.$http.getSignList(this.search).then(res => {
        this.dataInfo = res.data
        this.itemTotal = res.data.count - 0
      })
    },
    getOrderInfo(row) {
      this.$http.getOrderInfo({ order_id: row.order_id }).then(res => {
        this.orderDetail = res.data
        this.dialogVisible1 = true
      })
    },
    getInvoice(row, val) {
      this.$http.getInvoice({ order_id: row.order_id }).then(res => {
        this.invoiceDetail = res.data
        this.invoiceFlag = val
        this.dialogVisible2 = true
      })
    },
    setInvoice(row, val) {
      this.invoiceFlag = val
      this.invoiceDetail = {}
      this.invoiceDetail.order_id = row.order_id
      this.dialogVisible2 = true
    },
    confirmSetInvoice() {
      const invoiceDetail = {
        order_id: this.invoiceDetail.order_id,
        invoice_type: this.invoiceDetail.invoice_type,
        invoice_no: this.invoiceDetail.invoice_no,
        invoice_tax_rate: this.invoiceDetail.invoice_tax_rate
      }
      for (const key in invoiceDetail.invoice) {
        if (!invoiceDetail.invoice[key]) {
          this.$message({
            type: 'info',
            message: '请完善发票信息'
          })
          return
        }
      }
      this.$http.setInvoice(invoiceDetail).then(res => {
        if (res.code == '200') {
          this.dialogVisible2 = false
          this.$message({
            type: 'success',
            message: '编辑发票信息成功'
          })
          this.getSignList()
        }
      })
    },
    orderImg(row) {
      this.$refs.singleTable.setCurrentRow(row)
      this.dialogVisible3 = true
      this.src = row.extra.order_img
    },
    handleClose() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
    },
    tableSort(val) {
      this.search.order_key = val.prop
      this.search.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.search.p = 1
      this.getSignList()
    },
    handleSizeChange(val) {
      this.search.limit = val
    }
  }
}
</script>

<style lang="scss">
.el-icon-circle-close{
  color:white!important
}
.order-signing-detail {
  .export-btn {
    margin: 0 40px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .order-detail-invoice {
    .el-dialog__body {
      padding: 20px 40px;
    }
    div {
      margin-bottom: 15px;
    }
    .el-input {
      width: 240px;
    }
  }
  .order-img .el-dialog {
    height: 95% !important;
    .el-dialog__body {
      height: 90%;
    }
    .agreement_picture,
    .pdf {
      height: 100%;
    }
  }
}
</style>
